import { UiService } from '@adaptiva/core/ui';
import { BaseWidgetComponent, WidgetService } from '@adaptiva/core/widgets';
import { ICpeInfo } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component, Input, forwardRef } from '@angular/core';

@Component({
	standalone: false,
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'ada-cpe-info-view',
	templateUrl: 'cpe-info-view.component.html',
	providers: [
		WidgetService,
		{ provide: BaseWidgetComponent, useExisting: forwardRef(() => CpeInfoViewComponent) },
	]
})
export class CpeInfoViewComponent extends BaseWidgetComponent {
	@Input()
	public cpeInfo: ICpeInfo;

	constructor(
		public ui: UiService,
		_widgetService: WidgetService
	) {
		super(_widgetService);
	}
}
